export const STATUS_TEXT = {
  '0': '生成中',
  '1': '已生成',
  '2': '生成失败',
};

export const PAGE_SIZE = 20;

export const REPORT_INFO = {
  normal: {
    reason: '正常业务波动',
    solution: '请联系客服排查问题，',
    linkText: '在线客服',
    // link: 'https://www.yfanqie.com/xlkf',
    link: '/customerService',
  },
  offline: {
    reason: '网络不在线',
    solution: '请务必保持在线并保证晚高峰（18:00-22:00)在线',
    linkText: '',
    link: '',
  },
  pingLost: {
    reason: '高丢包',
    solution: '建议降低丢包率至2%以下，',
    linkText: '去优化丢包率',
    link: 'https://help.yfanqie.com/c165/bcd3',
  },
  diskUnrecognized: {
    reason: '未识别到磁盘',
    solution: '未识别到磁盘，请连接磁盘并确保易驱线正常，建议480g SSD，',
    linkText: '详细攻略',
    link: 'https://help.yfanqie.com/c165/e6bb',
  },
  diskUnformatted: {
    reason: '磁盘未格式化',
    solution: '您的磁盘未格式化将无收益，请先格式化硬盘，',
    linkText: '如何格式化',
    link: 'https://help.yfanqie.com/c165/e6bb',
  },
  diskMalfunc: {
    reason: '磁盘故障',
    solution: '您的磁盘无法使用，请更换磁盘，推荐480G SSD，',
    linkText: '详细攻略',
    link: 'https://help.yfanqie.com/c165/e6bb',
  },
  diskAbnormal: {
    reason: '磁盘异常',
    solution: '您的磁盘异常，请尝试重启->格式化->更换480G SSD排查原因，',
    linkText: '详细攻略',
    link: 'https://help.yfanqie.com/c165/e6bb',
  },
  deploying: {
    reason: '部署中设备',
    solution:
      '等待5-7天部署期收益将恢复正常可能原因：设备新上线，可能有5-7天低收益，请耐心等待；更换了新磁盘，后台正在部署请保持在线',
    linkText: '',
    link: '',
  },
  other: {
    reason: '其他',
    solution: '运营商网络/区域限制，请更换指定运营商/区域',
    linkText: '',
    link: '',
  },

  //   '3': {
  //     reason: 'nat差',
  //     solution: '建议nat类型改公网型,',
  //     linkText: '去优化nat',
  //     link: 'https://baidu.com',
  //   },
};

export const REPORT_DATA = {
  module: 'device',
};

export const DEFAULT_TEXT = '--';
